/* Szállítási mód a kosárban (snippets/szallitasi-mod-valaszto.liquid vezérlője) — amnesia.hu-minta, 2026-09-06.
   Két sor: „Házhozszállítás" / „GLS csomagpont/box". A csomagpont-sor a GLS HIVATALOS térkép-webkomponensét nyitja
   (map.gls-hungary.com/widget/gls-dpm.js → <gls-dpm-dialog>, 'change' esemény: detail {id, name, type, contact{postalCode, city, address}, goldId…}).
   A választott pont kosár-attribútumba megy (/cart/update.js), a „Házhozszállítás" törli. A pénztárba a pont címe a kosár-form
   action-jében (/cart?checkout[shipping_address][…]) töltődik elő. App nem kell, nem-Plus bolton is megy. Globális + body-figyelő
   (a kosár-oldal AJAX-frissítése újrarendereli a blokkot — ezért a válasz után mindig a FRISS [data-szm] blokkot frissítjük). */
(function () {
  var GLS_SCRIPT = 'https://map.gls-hungary.com/widget/gls-dpm.js';
  var KULCS = { id: 'GLS_pont_id', nev: 'GLS_pont_nev', cim: 'GLS_pont_cim', tipus: 'GLS_pont_tipus', gold: 'GLS_pont_gold' };
  var dialog = null, scriptKerve = false, valasztottPont = null, mod = 'hazhoz';

  function glsScript() {
    if (window.customElements && customElements.get('gls-dpm-dialog')) return Promise.resolve();
    if (!scriptKerve) {
      scriptKerve = true;
      var s = document.createElement('script');
      s.type = 'module'; s.src = GLS_SCRIPT;
      document.head.appendChild(s);
    }
    return customElements.whenDefined('gls-dpm-dialog');
  }

  function attribFrissit(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (r) { return r.json(); });
  }

  function cimBont(cim) {
    var m = String(cim || '').match(/^\s*(\d{4,5})\s+([^,]+?)\s*,\s*(.+)$/);
    return m ? { irsz: m[1], varos: m[2], utca: m[3] } : { irsz: '', varos: '', utca: String(cim || '') };
  }

  function pontAdat(d) {
    var c = (d && d.contact) || {};
    var irsz = c.postalCode || c.zipCode || c.zip || '';
    var varos = c.city || '';
    var utca = c.address || d.address || '';
    var tipus = /locker|automata/i.test(String(d.type || '')) || /^GLS Automata/i.test(String(d.name || '')) ? 'automata' : 'csomagpont';
    return {
      id: String(d.id || ''), nev: String(d.name || ''),
      cim: (irsz + ' ' + varos + ', ' + utca).replace(/^\s+|\s+$/g, '').replace(/^,\s*/, ''),
      irsz: String(irsz), varos: String(varos), utca: String(utca), tipus: tipus,
      gold: String(d.goldId || d.externalId || '')
    };
  }

  function aktualisRoot() { return document.querySelector('[data-szm]'); }

  function uiFrissit(root) {
    if (!root) return;
    var hazhoz = root.querySelector('[data-szm-mod="hazhoz"]');
    var csp = root.querySelector('[data-szm-mod="csomagpont"]');
    var blokk = root.querySelector('[data-szm-pont]');
    var hiba = root.querySelector('[data-szm-hiba]');
    var van = !!(valasztottPont && valasztottPont.id);
    if (van) mod = 'csomagpont';
    var cspAktiv = mod === 'csomagpont';
    root.dataset.szmPontId = van ? valasztottPont.id : '';
    hazhoz.classList.toggle('szm__sor--aktiv', !cspAktiv); hazhoz.setAttribute('aria-checked', String(!cspAktiv));
    csp.classList.toggle('szm__sor--aktiv', cspAktiv); csp.setAttribute('aria-checked', String(cspAktiv));
    if (van) {
      root.querySelector('[data-szm-pont-nev]').textContent = valasztottPont.nev;
      root.querySelector('[data-szm-pont-cim]').textContent = valasztottPont.cim;
      blokk.hidden = false;
    } else blokk.hidden = true;
    if (hiba) hiba.hidden = true;
  }

  function pontMent(d) {
    var p = pontAdat(d);
    if (!p.id) return;
    var a = {}; a[KULCS.id] = p.id; a[KULCS.nev] = p.nev; a[KULCS.cim] = p.cim; a[KULCS.tipus] = p.tipus; a[KULCS.gold] = p.gold;
    valasztottPont = p; mod = 'csomagpont';
    uiFrissit(aktualisRoot());
    attribFrissit(a).then(function () { uiFrissit(aktualisRoot()); tetelTulajdonsag(jelolo(p)); }).catch(function () { uiFrissit(aktualisRoot()); });
  }

  function pontTorol() {
    var a = {}; a[KULCS.id] = null; a[KULCS.nev] = null; a[KULCS.cim] = null; a[KULCS.tipus] = null; a[KULCS.gold] = null;
    valasztottPont = null; mod = 'hazhoz';
    uiFrissit(aktualisRoot());
    attribFrissit(a).then(function () { uiFrissit(aktualisRoot()); tetelTulajdonsag(null); }).catch(function () { uiFrissit(aktualisRoot()); });
  }

  function terkepNyit(root) {
    glsScript().then(function () {
      if (!dialog) {
        dialog = document.createElement('gls-dpm-dialog');
        dialog.setAttribute('country', (root && root.dataset.szmCountry) || 'hu');
        dialog.setAttribute('language', (root && root.dataset.szmLang) || 'hu');
        document.body.appendChild(dialog);
        dialog.addEventListener('change', function (e) {
          if (e && e.detail) pontMent(e.detail);
          try { dialog.close(); } catch (err) { /* nincs close */ }
        });
      }
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }).catch(function () {
      var r = aktualisRoot(); var hiba = r && r.querySelector('[data-szm-hiba]');
      if (hiba) hiba.hidden = false;
    });
  }

  // A pont-előtöltés JELE (localStorage): ha egyszer pont címével mentünk a pénztárba, a Shopify a kosár-tokenhez kötött pénztárban
  // ŐRZI a pont címét és az address2-jelölőt → a vevő házhozszállításra váltva a pont címét és díj-sorát kapta (2026-09-07 lelet).
  // Ezért házhoznál is friss tokennel, ÜRES címmel megyünk, ha a jel be van állítva; sikeres újraépítéskor a jel törlődik.
  var PONT_JEL = 'szm_pont_elotoltve';
  function pontJel(be) { try { if (be) localStorage.setItem(PONT_JEL, '1'); else localStorage.removeItem(PONT_JEL); } catch (err) { /* privát mód */ } }
  function voltPontElotoltes() { try { return localStorage.getItem(PONT_JEL) === '1'; } catch (err) { return false; } }

  // ÚJ KOSÁR-TOKEN a pontos pénztár előtt: a Shopify a pénztárban (kosár-tokenhez kötve) megjegyzi a korábban kijelölt szállítási módot,
  // így „pénztár → vissza → pont választása → pénztár" után a házhoz-sor maradna kijelölve. Friss kosárral a pénztár is friss: az első
  // sor (a pont díja) a kijelölt. Lépések: /cart.js → cart-süti lejáratása → /cart/add.js (tételek) → /cart/update.js (attribútumok,
  // megjegyzés) → a form beküldése a cím-előtöltéssel. Hiba esetén a régi kosárral megyünk tovább.
  function ujKosarMajdPenztar(form, p) {   // p = a pont (cím-előtöltés) VAGY null (házhoz: friss pénztár üres címmel)
    var fej = { 'Content-Type': 'application/json' }, opts = { credentials: 'same-origin', cache: 'no-store' };
    var cel = p ? '/checkout?' + cimParam(p) : '/checkout', kesz = false;
    if (p) pontJel(true);
    function tovabb() { if (kesz) return; kesz = true; location.assign(cel); }   // GET: a Shopify a checkout[...] paramokból tölti a címet
    var vedo = setTimeout(tovabb, 6000);   // lassú hálózat: 6 mp után mindenképp pénztár (legfeljebb a kijelölés nem friss)
    fetch('/cart.js', opts).then(function (r) { return r.json(); }).then(function (c) {
      var jel = p ? jelolo(p) : null;
      var items = (c.items || []).map(function (i) {
        var o = { id: i.variant_id, quantity: i.quantity };
        o.properties = {}; Object.keys(i.properties || {}).forEach(function (k) { if (k !== PONT_TUL) o.properties[k] = i.properties[k]; });
        if (jel) o.properties[PONT_TUL] = jel;   // az újraépített kosár minden tétele hordozza a pont jelölőjét
        if (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan) o.selling_plan = i.selling_plan_allocation.selling_plan.id;
        return o;
      });
      if (!items.length) return;
      var regiToken = c.token, attrs = c.attributes || {}, note = c.note || '';
      var lejar = '; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      document.cookie = 'cart=' + lejar;
      document.cookie = 'cart=' + lejar + '; domain=' + location.hostname;
      return fetch('/cart.js', opts).then(function (r) { return r.json(); }).then(function (c2) {
        // csak akkor építünk újra, ha a süti törlése tényleg ÚJ, ÜRES kosarat adott — különben maradna a régi (nincs duplázás)
        if (!c2 || c2.token === regiToken || (c2.item_count || 0) > 0) return tetelTulajdonsag(jel || null);   // nincs újraépítés → a tulajdonságot tételenként pótoljuk
        return fetch('/cart/add.js', { method: 'POST', headers: fej, credentials: 'same-origin', body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart/update.js', { method: 'POST', headers: fej, credentials: 'same-origin', body: JSON.stringify({ attributes: attrs, note: note }) }); })
          .then(function (r) { if (!p && r && r.ok) pontJel(false); return r; })   // házhoz: a friss pénztár már nem hordozza a pont címét → a jel törölhető;
      });
    }).catch(function () { /* marad a régi kosár */ }).then(function () { clearTimeout(vedo); tovabb(); });
  }

  // A pont jelölője („Átvételi pont: <név> (<id>)"): a cím 2. sorába (vendég) ÉS a tételek rejtett _gls_pont tulajdonságába (bejelentkezett,
  // mentett címes vevőnél a Shopify a cím-előtöltést eldobja, a tétel-tulajdonságot viszont a díj-kérés mindig viszi) — a TEXTICO mindkettőből felismeri.
  var PONT_TUL = '_gls_pont';
  function jelolo(p) { return p && p.nev && p.id ? 'Átvételi pont: ' + p.nev + ' (' + p.id + ')' : ''; }

  // A kosár minden tételére ráteszi (jel) vagy leveszi (null) a rejtett tulajdonságot — sorban, /cart/change.js-szel (a tétel kulcsa változik,
  // ezért mindig friss /cart.js-ből dolgozik). A vevő nem látja (aláhúzásos tulajdonság), az ár nem változik.
  function tetelTulajdonsag(jel) {
    var fej = { 'Content-Type': 'application/json' }, opts = { credentials: 'same-origin', cache: 'no-store' };
    function egy() {
      return fetch('/cart.js', opts).then(function (r) { return r.json(); }).then(function (c) {
        var t = (c.items || []).find(function (i) { var v = (i.properties || {})[PONT_TUL] || ''; return jel ? v !== jel : !!v; });
        if (!t) return;
        var props = {}; Object.keys(t.properties || {}).forEach(function (k) { if (k !== PONT_TUL) props[k] = t.properties[k]; });
        if (jel) props[PONT_TUL] = jel;
        return fetch('/cart/change.js', { method: 'POST', headers: fej, credentials: 'same-origin', body: JSON.stringify({ id: t.key, quantity: t.quantity, properties: props }) })
          .then(function (r) { if (!r.ok) throw new Error('change'); return egy(); });
      });
    }
    return egy().catch(function () { /* a pénztár előtti újraépítés még pótolja */ });
  }

  function cimParam(p) {
    var e = encodeURIComponent, orsz = ((dialog && dialog.getAttribute('country')) || 'hu').toUpperCase();
    var jel = jelolo(p);
    return 'checkout[shipping_address][address1]=' + e(p.utca) + '&checkout[shipping_address][city]=' + e(p.varos)
      + '&checkout[shipping_address][zip]=' + e(p.irsz) + '&checkout[shipping_address][country]=' + e(orsz)
      + (jel ? '&checkout[shipping_address][address2]=' + e(jel) : '');
  }

  function bekot(root) {
    if (root.__szm) return;
    root.__szm = true;
    // induló állapot a Liquid-ből (kosár-attribútumok)
    if (root.dataset.szmPontId && !valasztottPont) {
      var cim = (root.querySelector('[data-szm-pont-cim]') || {}).textContent || '';
      var b = cimBont(cim);
      valasztottPont = { id: root.dataset.szmPontId, nev: (root.querySelector('[data-szm-pont-nev]') || {}).textContent || '', cim: cim, irsz: b.irsz, varos: b.varos, utca: b.utca };
      mod = 'csomagpont';
    }
    uiFrissit(root);
    root.querySelector('[data-szm-mod="hazhoz"]').addEventListener('click', function () {
      if (valasztottPont) pontTorol(); else { mod = 'hazhoz'; uiFrissit(aktualisRoot()); }
    });
    root.querySelector('[data-szm-mod="csomagpont"]').addEventListener('click', function () {
      mod = 'csomagpont';
      uiFrissit(aktualisRoot());
      if (!valasztottPont) terkepNyit(aktualisRoot());
    });
    var modosit = root.querySelector('[data-szm-modosit]');
    if (modosit) modosit.addEventListener('click', function () { terkepNyit(aktualisRoot()); });
    // Pénztár: csomagpont-sor pont nélkül → tilt + térkép; ponttal → a cím előtöltése a pénztárba (amnesia-minta)
    // a fiókban a doboz a formon KÍVÜL van, a Pénztár gomb form="CartDrawer-Form" → a data-szm-form mondja meg, melyik formot figyeljük
    // (a kosár-oldalon a fiók formja előrébb van a DOM-ban → a #cart form az elsődleges tartalék, csak utána az első /cart form)
    var form = (root.dataset.szmForm && document.getElementById(root.dataset.szmForm)) || root.closest('form')
      || (!root.closest('cart-drawer') && document.getElementById('cart'))
      || document.querySelector('form[action$="/cart"], form[action*="/cart?"]');
    if (form && !form.__szmSubmit) {
      form.__szmSubmit = true;
      form.addEventListener('submit', function (e) {
        var r = aktualisRoot(); if (!r) return;
        if (mod === 'csomagpont' && !valasztottPont) {
          e.preventDefault(); var hiba = r.querySelector('[data-szm-hiba]'); if (hiba) hiba.hidden = false; terkepNyit(r); return;
        }
        if (valasztottPont && valasztottPont.utca) { e.preventDefault(); ujKosarMajdPenztar(form, valasztottPont); return; }
        if (mod === 'hazhoz' && voltPontElotoltes()) { e.preventDefault(); ujKosarMajdPenztar(form, null); return; }   // korábbi pont-előtöltés → friss pénztár, üres címmel
        form.setAttribute('action', '/cart');
      });
    }
  }

  function mindBekot() { document.querySelectorAll('[data-szm]').forEach(bekot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mindBekot); else mindBekot();
  new MutationObserver(function () { mindBekot(); }).observe(document.body, { childList: true, subtree: true });
})();
